import React from 'react';
import { defineMessages, InjectedIntlProps, injectIntl } from 'react-intl';

class PageTitle extends React.PureComponent<InjectedIntlProps> {
  componentDidMount(): void {
    document.title = this.props.intl.formatMessage(messages.pageTitle);
  }

  render() {
    return null;
  }
}

export default injectIntl(PageTitle);

const messages = defineMessages({
  pageTitle: {
    defaultMessage: 'Atlassian | Start page',
    description: 'Title of the page in the web browser. Start and page are not brand names, and should be translated.',
    id: 'uchi.pageTitle',
  },
});
